import Tag from '@atoms/Tag/Tag';
import { ILink } from '@models/ILink';

export interface IArticleTags {
  tags: ILink[];
}

const ArticleTags = ({ tags }: IArticleTags) => (
  <section className="tw-flex tw-w-full tw-flex-wrap tw-gap-4 tw-border-t tw-border-grey-20 tw-pt-4">
    {tags.map((tag) => (
      <span key={tag.text}>
        {tag.url ? (
          <Tag
            label={tag.text}
            href={tag.url}
            target={tag.target}
            as="a"
            largeText
          />
        ) : (
          <Tag label={tag.text} as="span" largeText />
        )}
      </span>
    ))}
  </section>
);

export default ArticleTags;
